var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('additional-details-form',{ref:"additionalDetailsRef",attrs:{"api-endpoint":_vm.apiEndpoint,"form-data-object":_vm.getAdditionalReloadCardOrderDetails},on:{"form-success":_vm.handleFormSuccess,"request-update":_vm.reloadActiveReloadFormData,"is-dirty":function($event){return _vm.$emit('is-dirty')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }